var _DATE_FORMATTERS;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import d3Legacy from 'd3-legacy';
import { getCurrentLanguage } from 'js/helpers/localization';
import { LANGUAGE_CODE_ENGLISH, LANGUAGE_CODE_SPANISH } from 'js/constants/localization';
export function getCurrentD3Locale() {
  return DATE_FORMATTERS[getCurrentLanguage()];
}
export function mapNumberToLocaleString(number) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return number.toLocaleString(getCurrentLanguage(), options);
}
var DATE_FORMATTERS = (_DATE_FORMATTERS = {}, _defineProperty(_DATE_FORMATTERS, LANGUAGE_CODE_SPANISH, d3Legacy.locale({
  decimal: ',',
  thousands: '.',
  grouping: [3],
  currency: ['€', ''],
  dateTime: '%a %b %e %X %Y',
  date: '%d/%m/%Y',
  time: '%H:%M:%S',
  periods: ['AM', 'PM'],
  days: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
  shortDays: ['Dom', 'Lun', 'Mar', 'Mi', 'Jue', 'Vie', 'Sab'],
  months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
  shortMonths: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
})), _defineProperty(_DATE_FORMATTERS, LANGUAGE_CODE_ENGLISH, d3Legacy.locale({
  decimal: '.',
  thousands: ',',
  grouping: [3],
  currency: ['$', ''],
  dateTime: '%a %b %e %X %Y',
  date: '%m/%d/%Y',
  time: '%H:%M:%S',
  periods: ['AM', 'PM'],
  days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
})), _DATE_FORMATTERS);